module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/night-rain-4da1509f3b2aae806b62eef9e27eae7f.svg";